import { render } from "./AddTask.vue?vue&type=template&id=75dff64a&scoped=true"
import script from "./AddTask.vue?vue&type=script&lang=js"
export * from "./AddTask.vue?vue&type=script&lang=js"

import "./AddTask.vue?vue&type=style&index=0&id=75dff64a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue practice\\My Vue3Projects\\todo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dff64a"]])

export default __exports__